import { render, staticRenderFns } from "./trialReport.vue?vue&type=template&id=10f518a4&scoped=true"
import script from "./trialReport.vue?vue&type=script&lang=js"
export * from "./trialReport.vue?vue&type=script&lang=js"
import style0 from "./trialReport.vue?vue&type=style&index=0&id=10f518a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f518a4",
  null
  
)

export default component.exports